export type TradeSide = 'buy' | 'sell';

interface TradeSideSource {
  readonly side?: string | null;
  readonly type?: string | null;
}

/**
 * Resolve direction from the semantic wire field. Explicit legacy buy/sell
 * types remain readable during rolling deploys; an ambiguous swap never
 * invents a direction.
 */
export function resolveTradeSide(row: TradeSideSource): TradeSide | undefined {
  if (row.side === 'buy' || row.side === 'sell') return row.side;
  if (row.side !== undefined && row.side !== null) return undefined;
  if (row.type === 'buy' || row.type === 'sell') return row.type;
  return undefined;
}
